// extracted by mini-css-extract-plugin
export var aircallIframe = "_j8-3";
export var fabContainer = "_j8-5";
export var fabRinging = "_j8-6";
export var loadingOverlay = "_j8-4";
export var pulse = "_j8-7";
export var widgetContent = "_j8-2";
export var widgetPanel = "_j8-0";
export var widgetPanelExpanded = "_j8-1";